/**
 * computeKrProgress — formula del progress 0..1 per KR numerici.
 *
 * Versione estratta da CoachStatePanel.renderKr per consentire unit test e
 * riuso. Manteniamo la stessa logica:
 *
 * - KR decrescente (target < baseline, es. "peso 78 → 72"):
 *     progress = (base - cur) / (base - target)
 * - KR crescente con baseline GENUINO (base !== cur AND base < target):
 *     progress = (cur - base) / (target - base)
 * - Fallback (baseline === cur o null o non coerente):
 *     progress = cur / target
 *
 * Ritorna `null` se l'input non è abbastanza numerico (KR di tipo tappa).
 */
export function computeKrProgress({ valore_attuale, target_committed, baseline, tipo, natura } = {}) {
  const tgt = target_committed;
  const v = valore_attuale;
  const isNum =
    (tipo === 'numerico') ||
    (natura === 'numerico') ||
    (typeof tgt === 'number' && typeof v === 'number');
  if (!isNum || tgt == null || v == null) return null;

  const target = Number(tgt);
  const cur = Number(v);
  const base = baseline != null ? Number(baseline) : null;

  let progress;
  if (base != null && base > target && cur <= base) {
    progress = (base - cur) / (base - target);
  } else if (base != null && base !== cur && base < target && cur >= base) {
    progress = (cur - base) / (target - base);
  } else if (target !== 0) {
    progress = cur / target;
  } else {
    progress = 0;
  }
  return Math.max(0, Math.min(1, progress));
}
